import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SEO } from "../components/SEO";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] bg-navy text-white flex items-center relative overflow-hidden" data-testid="not-found-page">
      <SEO title="Page Not Found" description="The page you are looking for could not be found." path="/404" />
      <div className="grain-overlay" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <p className="font-mono text-xs tracking-[0.35em] text-gold uppercase">Error 404</p>
        <h1 className="mt-6 font-serif font-bold text-6xl sm:text-8xl tracking-tight">
          Page Not <span className="text-gold italic">Found</span>
        </h1>
        <p className="mt-6 text-slate-400 max-w-md mx-auto leading-relaxed">
          The page you are looking for does not exist or may have been moved.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-button"
          className="mt-10 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-bold text-navy hover:bg-gold-bright transition-colors"
        >
          <ArrowLeft size={16} /> Return to Home
        </Link>
      </div>
    </div>
  );
}
